import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { DefaultLang, Languages } from "../constants/languages.constant";

@Injectable({ providedIn: 'root' })
export class LanguageService {
  public languages: string[] = Languages;

  constructor(public translate: TranslateService, private cookieService: CookieService) {
    let browserLang;
    this.translate.addLangs(this.languages);
    if (this.cookieService.check('lang')) {
      browserLang = this.cookieService.get('lang');
    }
    else {
      this.setLanguage(DefaultLang);
      browserLang = translate.getBrowserLang();
    }
    translate.use(browserLang.match(/en|tr/) ? browserLang : DefaultLang);
  }

  public setLanguage(lang) {
    this.translate.use(lang);
    this.cookieService.set('lang', lang);
  }

}
